import SourceFactory from '@components/sources/sourceFactory';
import { coerceRetlSubcategory, getOrigin } from '@stores/util';
import { SourceDefinitionCategory, WarehouseSourceOrigin } from '@stores/types';
import type { WorkspaceType } from '@stores/workspace';
import { SourceConfig } from './types';

export const getSourceCategory = (
  sourceDefCategory: SourceDefinitionCategory,
  config: SourceConfig,
) =>
  // eslint-disable-next-line no-nested-ternary
  SourceFactory(sourceDefCategory).isWarehouse()
    ? {
        category: 'retl' as const,
        subcategory: coerceRetlSubcategory(getOrigin(config)),
      }
    : ['singer-protocol', 'cloud'].includes(sourceDefCategory ?? '')
    ? { category: 'extract' as const }
    : {
        category: 'event' as const,
      };

/** A `sql-audience` source of a Lookout sibling is a Lookout audience. Elsewhere it is an audience. */
export const isLookoutAudienceSource = (
  workspaceType: WorkspaceType | undefined,
  config: SourceConfig,
) => workspaceType === 'lookout' && getOrigin(config) === WarehouseSourceOrigin.SQL_AUDIENCE;
